import { Injectable } from '@angular/core';
import { marked, Renderer } from 'marked';

@Injectable({
  providedIn: 'root'
})
export class MarkdownService {
  constructor() {
    const renderer = new Renderer();

    // Custom link renderer: external links open in new tab, anchors scroll within container
    renderer.link = ({ href, title, text }) => {
      const titleAttr = title ? ` title="${title}"` : '';

      // Anchor links (e.g., #section-name) - use data attribute for in-page scrolling
      if (href?.startsWith('#')) {
        const anchorId = href.substring(1);
        return `<a href="javascript:void(0)" data-anchor="${anchorId}"${titleAttr} class="markdown-anchor">${text}</a>`;
      }

      // External links - open in new tab
      return `<a href="${href}" target="_blank" rel="noopener noreferrer"${titleAttr}>${text}</a>`;
    };

    // Custom heading renderer: add IDs for anchor navigation
    renderer.heading = ({ text, depth }) => {
      const id = text.toLowerCase()
        .replace(/<[^>]*>/g, '')  // Remove HTML tags
        .replace(/[^\w\s-]/g, '') // Remove special characters
        .replace(/\s+/g, '-')     // Replace spaces with hyphens
        .trim();
      return `<h${depth} id="${id}">${text}</h${depth}>`;
    };

    marked.setOptions({
      gfm: true,
      breaks: true,
    });

    marked.use({ renderer });
  }

  /**
   * Converts markdown string to HTML string
   * @param markdown The markdown content to render
   * @returns HTML string
   */
  renderToHtml(markdown: string): string {
    if (!markdown) {
      return '';
    }
    return marked.parse(markdown) as string;
  }
}
